import { useState, useEffect } from 'react';
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading.jsx';
import MergedTableHeader from '../../../component/common/dataGrid/MergedTableHeader.jsx';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import { EmptySalgu } from '../../../images/icons/icons_component.js';

const CurrentInput = () => {

    const today = new Date();
    const currentYear = String(today.getFullYear());
    let currentMonth = String(today.getMonth() + 1);
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchCheck2: currentMonth,
        searchYear: currentYear,
    });
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['기관명', '사전근무표', '사후근무표'];
    const dataColumn = ['EMOGDESC', 'BEF_CHECK', 'AFT_CHECK'];
    const apiCall = '/trmsapi/dutyschd/get_cur_status_dttb_data_list.do';

    const data = async () => {
        setIsLoading(true);
        try {
            const totalParams = {
                searchYyyyMm: searchParams.searchYear + searchParams.searchCheck2,
                userAuth: localStorage.getItem("userAuth"),
                userEmcd: localStorage.getItem("useremcd"),
            }
            const response = await axios.get(apiCall,
                { params: totalParams }
            );
            setDataList(response.data);
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        data();
    }, [searchParams.searchCheck2, searchParams.searchYear]);

    const { lightBackColor } = useDynamicStyle();

    return (
        <>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="90%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>등록년월</th>
                            <td>
                                <div className='flex gap-2'>
                                    <select id="searchYear"
                                        name="searchYear"
                                        value={searchParams.searchYear}
                                        onChange={handleInputChange}
                                    >
                                        {Array.from({ length: 10 }, (_, i) => {
                                            const year = (currentYear - i).toString()
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <select id="searchCheck2"
                                        name="searchCheck2"
                                        value={searchParams.searchCheck2}
                                        onChange={handleInputChange}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => {
                                            const month = (i + 1).toString().padStart(2, '0');
                                            return (
                                                <option key={month} value={month}>
                                                    {month}월
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='flex flex-col flex-grow min-h-0 h-full'>
                {isLoading ? <Loading /> :
                    <div className='data_grid_container mt-5'>
                        <hr className={`border-t-2 mr-1-1 tr_border_soft`} />
                        <div className={`data_list_table tr_border_soft`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    <EmptySalgu /> 해당하는 데이터가 없습니다.
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {dataList.map((item, rowIndex) => {
                                                const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                                return (
                                                <tr key={rowIndex} className={gridColor}>
                                                    {dataColumn.map((col, colIndex) => {
                                                        const cellStyle = 'text-center' + (((colIndex === 1 && item[col] === '입력') || (colIndex === 2 && item[col] === '확정')) && ' bg_tr_row');
                                                        return (
                                                            <td key={colIndex} className={cellStyle}>
                                                                {item[col]}
                                                            </td>
                                                        )
                                                    })}
                                                </tr>
                                            )})}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                    </div>
                }
            </div>
        </ >
    )
}

export default CurrentInput;